<div [attr.id]="fieldId" class="value-switch-field">
  <label
    *ngIf="label"
    [ngClass]="{
      disabled: formControl?.disabled
    }"
    class="switch-label field-label"
  >
    {{ label }}
  </label>

  <button
    type="button"
    *ngFor="let switch of switches"
    tabindex="0"
    class="switch-trigger"
    [disabled]="disabled"
    [ngClass]="{ selected: selectedValue === switch.value }"
    trackable
    [trackingObject]="switch.trackingObject"
    [trackingAction]="switch.trackingAction"
    [trackingAdditionalProperties]="switch.trackingAdditionalProperties"
    (click)="onClick(switch.value)"
  >
    {{ switch.key }}
  </button>
</div>

<p *ngIf="description" class="description">
  {{ description }}
</p>
